import { Module } from 'lib/vendor/terrific/Module';

import 'bootstrap/load-qtip';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { isMobilePage } from 'lib/util/helpers';

export default class CallOut extends Module {
	private content = '';
	private overwriteClass = '';
	private overwriteIconClass = '';
	private offsetOverrideX = 0;
	private offsetOverrideY = 2;

	private isMobile = false;
	private isMobileOnly = false;
	private isSDX = true;

	private $tip : JQuery | null = null;

	public on(callback : Hook) {
		const $ctx = this.$ctx;

		// Configuration
		this.content = $ctx.html();
		// <div data-class-overwrite="myPEXSpecialStyleInGrau"…
		this.overwriteClass = $ctx.data('class-overwrite') || '';
		this.overwriteIconClass = $ctx.data('icon-class-overwrite') || '';
		this.offsetOverrideX = $ctx.data('offset-override-x') || 0;
		this.offsetOverrideY = $ctx.data('offset-override-y') || 2;

		this.isMobileOnly = $ctx.is('.isMobileOnly');
		this.isMobile = isMobilePage();
		this.isSDX = $ctx.is('.sdx');

		this.log.debug('content', this.content);

		$ctx.hide();

		callback();
	}

	public after() {
		const $ctx = this.$ctx;

		if (this.isMobileOnly && !this.isMobile) {
			// Render as text on desktop
			$ctx.removeClass('mod modCallOut isMobileOnly').attr('style', '');

			return;
		}
		if (this.isMobile) {
			const $tabNav = this.$ctx.closest('.modTabNavigation');
			const tabNav = this.sandbox.getModuleInstance($tabNav, 'TabNavigation');
			if (tabNav) {
				this.sandbox.subscribe((tabNav as any).channel, this);
			}
		}

		if(!this.isSDX) {
			this.$tip = $('<span/>');
			this.$tip.addClass('scs-icon info-callout');
		} else {
			this.$tip = $('<i/>');
			this.$tip.addClass('sdx icon icon-046-information-circle');
		}

		this.$tip
			.attr('title', this.content)
			.addClass(this.overwriteClass)
			.addClass(this.overwriteIconClass)
			.insertBefore(this.$ctx)
			.before(' ')
			.after(' ');

		const configuration = this.isMobile ? this.mobileConfiguration() : this.desktopConfiguration();
		this.$tip.qtip(configuration);
	}

	public stop() {
		if(this.$tip) {
			this.$tip.qtip('destroy', true);
			this.$tip.remove();
			this.$tip = null;
		}
		Object.getPrototypeOf(Object.getPrototypeOf(this)).stop.apply(this, arguments);
	}

	/**
	 * This function returns configuration object for jQuery tooltip plug-in
	 * qTip. This configuration object is used on mobile.
	 *
	 * @method mobileConfiguration
	 * @return Configuration object for jQuery tooltip plug-in qTip.
	 */
	public mobileConfiguration() : QTip2.QTipOptions {
		const config : QTip2.QTipOptions = {
			content: {
				button: 'close',
				title: {
					text: ' ',
				},
			},
			events: {
				hide: () => {
					this.$tip!.removeClass('mobile-active');
				},
				show: () => {
					this.$tip!.addClass('mobile-active');
				},
			},
			hide: {
				event: 'click',
			},
			show: {
				event: 'click',
				solo: true,
			},
			style: {
				classes: 'ui-tooltip-mobile',
			},
		};

		const $modalParent = this.$ctx.closest('.modal');
		if($modalParent.length) {
			config.position = {
				container: $modalParent.find('.modal__content'),
			};

			(config.content as any).title.button = $(
				'<i class="icon icon-022-close icon--s2 font--semi-bold sc-navy" aria-hidden="true"></i>',
			);
		}

		return config;
	}

	/**
	 * This function returns configuration object for jQuery tooltip plug-in
	 * qTip. This configuration object is used on desktop.
	 *
	 * @method desktopConfiguration
	 * @return Configuration object for jQuery tooltip plug-in qTip.
	 */
	public desktopConfiguration() : QTip2.QTipOptions {
		const config : QTip2.QTipOptions = {
			position: {
				adjust: {
					x: this.offsetOverrideX,
					y: this.offsetOverrideY,
				},
				at: 'top center',
				my: 'bottom center',
				viewport: $(document.documentElement),
			},
			style: {
				classes: `${this.overwriteClass} scs-callout ${this.isSDX ? ' sdx' : ''}`,
				tip: {
					corner: true,
					height: 6,
					width: 8,
				},
			},
		};

		const $modalParent = this.$ctx.closest('.modal');
		if($modalParent.length) {
			(config.position as QTip2.Position).container = $modalParent;
		}

		return config;
	}

	/**
	 * This function hides callout when tab is changed.
	 *
	 * @method onActivateTab
	 * @return void
	 */
	public onActivateTab() {
		this.$tip!.qtip('hide');
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/sdx/Tc.Module.CallOut.ts